<template>
  <div class="download-file">
    <div class="download-file-content">
      <h2 class="download-file-help">
        请复制链接至其他浏览器下载文件
      </h2>
      <p class="download-file-src">
        {{ src }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'

export default {
  data() {
    return {
      compPayloadKey: this.$route.query.key,
      src: ''
    }
  },
  computed: {
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload
    })
  },
  created() {
    this.src = this.compPayload[this.compPayloadKey].value && this.compPayload[this.compPayloadKey].value.src
    if (this.src) this.src += '&download=download'
  }
}
</script>

<style lang="scss" scoped>
.download-file {
  height: 100vh;
  .download-file-content {
    margin: 40% 1rem 0;
    text-align: center;
    .download-file-help {
      font-size: 1.5rem;
      font-weight: bold;
    }
    .download-file-src {
      width: 100%;
      word-break: break-all;
      margin-top: 2rem;
      line-height: 16px;
    }
  }
}
</style>
